// Enter só confirma uma opção quando a lista está visível. O evento continua
// propagando para os atalhos de avanço definidos nas rotinas.
export function mapearTeclasSelect(handlers, select) {
  const confirmar = handlers[13]
  return { ...handlers, 13: event => {
    if (event.ctrlKey || event.altKey || event.metaKey || event.isComposing || event.repeat) return
    if (!select.dropdownOpen) return
    if (select.$attrs?.['data-pesquisa-contexto'] && !String(select.search || '').trim()) return
    return confirmar?.(event)
  } }
}
